import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  searchContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: '10px 0',
  },
}));
